import axios from "axios";

const getAuthHeader = () => {
  const tokenStr = localStorage.getItem("user");
  if (tokenStr) {
    const token = JSON.parse(tokenStr).token;
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

const API_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/dep-profiles`;
const EVENTS_URL = `${process.env.REACT_APP_BACKEND_SERVER}/api/enrollment-events`;

const jsonHeaders = () => ({ ...getAuthHeader(), "Content-Type": "application/json" });

const list = async () => {
  const { data } = await axios.get(API_URL, { headers: getAuthHeader() });
  return data;
};

const getOne = async (id) => {
  const { data } = await axios.get(`${API_URL}/${encodeURIComponent(id)}`, { headers: getAuthHeader() });
  return data;
};

const getSkipSetupItems = async () => {
  const { data } = await axios.get(`${API_URL}/skip-setup-items`, { headers: getAuthHeader() });
  return data;
};

const define = async (payload) => {
  const { data } = await axios.post(API_URL, { define: true, ...payload }, { headers: jsonHeaders() });
  return data;
};

const update = async (id, payload) => {
  const { data } = await axios.put(`${API_URL}/${encodeURIComponent(id)}`, payload, { headers: jsonHeaders() });
  return data;
};

const remove = async (id) => {
  const { data } = await axios.delete(`${API_URL}/${encodeURIComponent(id)}`, { headers: getAuthHeader() });
  return data;
};

const listEvents = async (params = {}) => {
  const { data } = await axios.get(EVENTS_URL, { headers: getAuthHeader(), params });
  return data.events || [];
};

const depProfileService = {
  list,
  getOne,
  getSkipSetupItems,
  define,
  update,
  remove,
  listEvents,
};
export default depProfileService;
